import cookie from './cookie';

// This function is used to check if the user isn't authenticated then
// show a notice modal to inform the user that the domain has changed
// and they need to login again.
export const checkAuthAndShowNotice = (modalStore, history) => {
  const params = new URLSearchParams(window.location.search);
  const isAuthed = params.get('authed') === '1';

  if (isAuthed) {
    const mbId = cookie.getCookie('mb_id');
    const sessionId = cookie.getCookie('session_id');

    // If redirected with authed=1 but missing cookies, show notice
    if (!mbId || !sessionId) {
      // Show modal first
      modalStore.openConfirmModal({
        title: '도메인 변경 안내!',
        message:
          'Named.com 도메인이 nmd.co로 변경될 예정입니다.\n서비스를 계속 이용하시려면 named.com에 사용하시던 계정으로 nmd.co에 로그인해주세요.\n네임드 서비스를 이용해주셔서 감사드리며, 더 나은 서비스를 위해 항상 노력하겠습니다.',
        okCallback: () => history?.push('/auth/login'),
      });

      // Clean up URL after modal is shown
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('authed');
      window.history.replaceState({}, '', newUrl);
    } else {
      // If auth is valid, still clean up the URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('authed');
      window.history.replaceState({}, '', newUrl);
    }
  }
};
